<div mat-dialog-content>
  <table mat-table [dataSource]="data">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="before">
      <th mat-header-cell *matHeaderCellDef>Before</th>
      <td mat-cell *matCellDef="let element">{{ element.before }}</td>
    </ng-container>

    <ng-container matColumnDef="after">
      <th mat-header-cell *matHeaderCellDef>After</th>
      <td mat-cell *matCellDef="let element">{{ element.after }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
